export const environment = {
  API_SERVER_HOST: 'onyxcs-am-service.app.onyxcentersource.com',
  OCD_SERVER_HOST: 'ocd.service.onyxcentersource.com',
  OLD_CS_AM_URL: 'https://commissions.onyxcentersource.com/pfscs/servlet/AccountServlet'
};
